import { each } from 'lodash';
import {
  QUESTION_MATRIX_OPEN_ENDED_STYLES,
  QUESTION_MATRIX_OPEN_ENDED_INPUT_SIZES,
} from './constants';

// Expand and collapse a row when needed
export function toggleQuestionCollapse(element) {
  const target = $(element).closest('.answer--matrix-open-ended-row-label');
  const answersDiv = $(target).siblings(
    '.answer--matrix-open-ended-content-wrapper',
  );
  if (target.hasClass('answer--matrix-open-ended-row-label--closed')) {
    answersDiv.slideDown();
    target.removeClass('answer--matrix-open-ended-row-label--closed');
  } else {
    answersDiv.slideUp();
    target.addClass('answer--matrix-open-ended-row-label--closed');
  }
}

export function onScrollDownMessage() {
  let hasEmptyAnswer = false;
  each($('.answer--matrix-open-ended-answer-input'), (answerElement) => {
    if (
      $(answerElement).attr('data-input-required') === 'true' &&
      $(answerElement).val() === ''
    ) {
      hasEmptyAnswer = true;
    }
  });

  if (
    !hasEmptyAnswer &&
    !$('[data-btn="submit-btn"]').isOnScreen() &&
    Pollfish.helper.flag.showScrollDownMsg
  ) {
    Pollfish.helper.flag.showScrollDownMsg = false;
    Pollfish.ui.prompt(Pollfish.ui.getText('scroll_down'));
  }
}

export function getRowClass(style) {
  if (style === QUESTION_MATRIX_OPEN_ENDED_STYLES.VERTICAL) {
    return 'answer--matrix-open-ended-vertical';
  }
  return 'answer--matrix-open-ended-horizontal';
}

export function getInputClass(style) {
  if (style === QUESTION_MATRIX_OPEN_ENDED_INPUT_SIZES.SMALL) {
    return 'answer--matrix-open-ended-answer-input-small';
  }
  if (style === QUESTION_MATRIX_OPEN_ENDED_INPUT_SIZES.MEDIUM) {
    return 'answer--matrix-open-ended-answer-input-medium';
  }
  if (style === QUESTION_MATRIX_OPEN_ENDED_INPUT_SIZES.LARGE) {
    return 'answer--matrix-open-ended-answer-input-large';
  }
  return 'answer--matrix-open-ended-answer-input-full';
}
